//coded by Narain on (11/09/2024)

export const fetchBotResponse = async (userInput) => {
    try {
      const response = await fetch('URL', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ role: 'user', content: userInput }),
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      return data.content;
    } catch (error) {
      console.error('Error fetching bot response:', error);
      return 'An error occurred while fetching the response.';
    }
  };
  